<div class="app-container">
  <app-header></app-header>
  <p-toast></p-toast>
  @if (loading) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
  }

  <div class="page">
    <router-outlet></router-outlet>
  </div>
  <div class="spacer"></div>
  <app-footer></app-footer>
  <p-confirmDialog></p-confirmDialog>
</div>
